import { action, observable } from 'mobx';
import { useStaticRendering } from 'mobx-react';
import ApiCore from '../ApiCore';

const isServer = !process.browser;
useStaticRendering(isServer);

class VirtueStore {
  @observable virtue = {};

  @observable virtues = [];

  // temporary value that is later
  // saved to the user
  @observable progressValue = 1;

  // sets if the virtue list is open
  // on the virtue-show page
  @observable virtueListIsOpen = false;

  // sets the index of the lesson
  // from the selected virtue
  @observable currentLesson = 0;

  // sets the type of content rendered
  // from the selected lesson
  @observable contentType = 'text';

  // if the content is too long
  // this switches between showing
  // or hiding all
  @observable showAllContent = false;

  // constructor(isServer, initialData = {}) {
  //   super();
  // }

  /**
   * Gets all virtues available.
   */
  @action async index() {
    if (this.virtues.length > 0) return this.virtues;

    return new Promise((resolve) => {
      ApiCore.get('/wp/v2/posts?categories=2&per_page=100&orderby=slug&order=asc')
        .then((response) => {
          this.virtues = response.data;
          resolve();
        });
    });
  }

  /**
   * Gets a specific virtue by slug.
   * @param {string} slug Virtue slug
   */
  @action show = async (slug) => {
    if (this.virtues.length === 0) await this.index();

    const foundVirtue = this.virtues.find(virtue => virtue.slug === slug);

    this.virtue = foundVirtue;
  };

  // these actions control the content
  // shown on the virtue-show page
  /**
   * gets a boolean from virtue-show page
   * if set true the list is shown
   * @param {boolean} state
   */
  @action toggleVirtueList(state) {
    this.virtueListIsOpen = state;
  }

  /**
   * gets a number from virtue show page
   * sets the index of lesson rendered
   * @param {int} number
   */
  @action setCurrentLesson(number) {
    this.currentLesson = number;
  }

  /**
   * gets a 'text' or 'video' string on
   * virtue-show page sets content shown accordingly
   * @param {string} state
   */
  @action setContentType(content) {
    this.contentType = content;
  }

  /**
   * if the content is long renders a button
   * which toggles this between true and false
   * if true the whole content is shown
   * @param {boolean} state
   */
  @action toggleShowAllContent(state) {
    this.showAllContent = state;
  }

  @action setProgressValue(value) {
    this.progressValue = value;
  }
}

let virtueStore = null;

export default function initializeVirtueStore(initialData) {
  if (isServer) {
    return new VirtueStore(isServer, initialData);
  }

  if (virtueStore === null) {
    virtueStore = new VirtueStore(isServer, initialData);
  }

  return virtueStore;
}
